import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Button,
  Row,
  DatePicker,
  Col,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Item } = Form;

const OrderFilterForm = ({
  onSearch,
}) => (
  <Form
    layout="vertical"
    onFinish={(values) => {
      const {
        orderId,
        startOrderDate,
        endOrderDate,
      } = values;
      onSearch({
        orderId,
        startOrderDate,
        endOrderDate,
      });
    }}
  >
    <Row gutter={12} align="middle">
      <Col xs={24} sm={24} md={12} lg={9} xl={8}>
        <Item label="ID DA VENDA" name="orderId">
          <Input placeholder="ID" />
        </Item>
      </Col>
      <Col xs={24} sm={24} md={10} lg={15} xl={10} style={{ display: 'flex', alignItems: 'center' }}>
        <Item label="DATA DA VENDA" name="startOrderDate" style={{ marginRight: 10 }}>
          <DatePicker
            format="DD/MM/YYYY"
            placeholder="Início"
          />
        </Item>
        <Item label=" " name="endOrderDate">
          <DatePicker
            format="DD/MM/YYYY"
            placeholder="Fim"
          />
        </Item>
      </Col>
      <Col xs={24} sm={24} md={24} lg={24} xl={{ span: 2, offset: 2 }} style={{ textAlign: 'right' }}>
        <Button
          id="orders-filter-button"
          type="primary"
          icon={<SearchOutlined />}
          htmlType="submit"
        >
          Pesquisar
        </Button>
      </Col>
    </Row>
  </Form>
);

OrderFilterForm.propTypes = {
  onSearch: PropTypes.func,
};

export default memo(OrderFilterForm);
